import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { getDownloadURL, useDownloadableDialogs } from "./DownloadableDialogs";
import DownloadIcon from "@mui/icons-material/Download";
import { EResourceService } from "@tlc/ls2pac/dto/ReturnLoan";
import { useAccount } from "@tlc/ls2pac/components/Account";
import { AvailabilitySource } from "../../../../contexts/EResourceAvailabilityContext";
import { useCallback, useMemo } from "react";
import { Button, ButtonProps, Tooltip } from "@mui/material";
import { EResourceCheckoutResponse } from "./DownloadableCheckoutDialog";
import { useDownloadNowBlocked } from "./useDownloadNowBlocked";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import React from "react";
interface DownloadNowButtonProps extends Omit<ButtonProps<"a">, "onClick"> {
  itemId:
    | EResourceCheckoutResponse["itemId"]
    | HostSystemItemView["eresourceId"];
  service:
    | EResourceCheckoutResponse["service"]
    | AvailabilitySource["service"]
    | HostSystemItemView["eresourceService"];
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  buttonText?: string;
}
export function DownloadNowButton({
  itemId,
  service,
  onClick,
  buttonText,
  disabled,
  variant,
  ...buttonProps
}: DownloadNowButtonProps) {
  const { openOverdriveIFrameDialog } = useDownloadableDialogs();
  const downloadNowBlocked = useDownloadNowBlocked();
  const { patron } = useAccount();
  const downloadButtonUrl = useMemo(
    () => getDownloadURL(itemId, service, patron?.patronId),
    [itemId, service, patron?.patronId],
  );
  const { translate } = useLanguage();

  const onClickDownloadNow = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (service === EResourceService.overdrive) {
        // show overdrive dialog
        // prevent default link behavior
        openOverdriveIFrameDialog({ src: downloadButtonUrl });
        event.stopPropagation();
        event.preventDefault();
      }
      if (onClick && typeof onClick === "function") onClick(event);
    },
    [service, onClick, openOverdriveIFrameDialog, downloadButtonUrl],
  );

  return (
    <Tooltip
      title={
        downloadNowBlocked
          ? translate("eResourceStationLocationMessage")
          : undefined
      }
    >
      {/* startIcon needs to come before buttonProps so that it can be explicitly removed */}
      <Button
        startIcon={<DownloadIcon />}
        {...buttonProps}
        disabled={disabled || downloadNowBlocked}
        variant={variant ?? "contained"}
        href={downloadButtonUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClickDownloadNow}
      >
        {buttonText || translate("download")}
      </Button>
    </Tooltip>
  );
}
